<script setup lang="ts">
// Seção "Atalhos" do dashboard Perfil (Recompensas, VIP Club, Promoções,
// Códiguinho, Baixar App). Extraída de ScreenProfile.vue pra poder ser
// renderizada em duas posições diferentes por breakpoint (mobile: logo
// abaixo dos saldos; desktop: onde sempre esteve, depois de Estatísticas)
// sem duplicar a lógica/markup — ver comentário em ScreenProfile.vue.
type Shortcut = {
  label: string;
  icon: string;
  to: string;
  comingSoon?: boolean;
};

const shortcuts = computed<Shortcut[]>(() => [
  {
    label: 'VIP Club',
    icon: getAssetsUrlForCDN('/images/user-v2/shortcut-vip.svg'),
    to: '/?open=levels',
  },
  {
    label: 'Recompensas',
    icon: getAssetsUrlForCDN('/images/user-v2/shortcut-rewards.svg'),
    to: '/user/rewards',
  },
  {
    label: 'Promoções',
    icon: getAssetsUrlForCDN('/images/user-v2/shortcut-promotions.svg'),
    to: '/promotions',
  },
  {
    label: 'Códiguinho',
    icon: getAssetsUrlForCDN('/images/user-v2/shortcut-promocode.svg'),
    to: '/promocode',
  },
  {
    label: 'Baixar App',
    icon: getAssetsUrlForCDN('/images/user-v2/shortcut-app.svg'),
    to: '/promotions/aplicativo',
  },
]);

const { close } = useUserV2Modal();

function onShortcutClick(shortcut: Shortcut) {
  if (shortcut.comingSoon) return;

  if (
    shortcut.to &&
    !shortcut.to.startsWith('/user/') &&
    shortcut.to !== '/promocode' &&
    !shortcut.to.startsWith('/?open=')
  ) {
    close();
  }
}

const NuxtLinkComponent = resolveComponent('NuxtLink');
</script>

<template>
  <section class="flex w-full flex-col gap-[10px]">
    <div
      class="flex h-[32px] w-full items-center rounded-[12px] bg-v2-default-300 pl-[12px]"
    >
      <p
        class="text-[14px] font-medium leading-[16px] text-white md:text-[12px]"
      >
        Atalhos
      </p>
    </div>

    <div class="no-scrollbar flex w-full gap-[10px] overflow-x-auto">
      <component
        :is="
          shortcut.comingSoon ? 'div' : shortcut.to ? NuxtLinkComponent : 'a'
        "
        v-for="shortcut in shortcuts"
        :key="shortcut.label"
        class="relative flex shrink-0 flex-col items-center gap-[5px] backdrop-blur-[8px]"
        :class="shortcut.comingSoon ? 'cursor-default' : ''"
        v-bind="
          shortcut.comingSoon
            ? {}
            : shortcut.to
              ? { to: localeLink(shortcut.to) }
              : { href: '#' }
        "
        @click="onShortcutClick(shortcut)"
      >
        <span
          class="flex size-[60px] items-center justify-center rounded-full border border-solid border-v2-default-700/40 bg-v2-default/40 p-[12px]"
        >
          <img
            alt=""
            class="size-[30px] object-contain"
            :src="shortcut.icon"
          />
        </span>
        <span
          class="text-center text-[10px] font-semibold leading-[16px] text-white"
        >
          {{ shortcut.label }}
        </span>

        <!-- "Em breve": cadeado cobre o atalho inteiro (ícone + texto) -->
        <BaseComingSoonOverlay
          v-if="shortcut.comingSoon"
          rounded="rounded-[12px]"
        />
      </component>
    </div>
  </section>
</template>

<style scoped>
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}
</style>
